<template>
  <div class="gb-page">
    <HeadNav selectedLanguage="en" page="download" />
    <BreadcrumbNav :items="[{ label: 'Download' }]" />

    <main class="download-main">
      <section class="download-hero">
        <div class="page-shell">
          <p class="eyebrow">APK download page</p>
          <h1>GB WhatsApp APK Download</h1>
          <p>{{ copy.hero }}</p>
          <button
            class="primary-btn"
            type="button"
            :disabled="!apk"
            @click="gotodownload"
          >
            Download GB WhatsApp APK
          </button>
        </div>
      </section>

      <section class="content-section file-section">
        <div class="page-shell file-layout">
          <div class="file-copy">
            <p class="section-kicker">APK file</p>
            <h2>Download GB WhatsApp APK File</h2>
            <p v-for="(text, idx) in copy.section1" :key="`d1-${idx}`">{{ text }}</p>
            <div class="file-chips">
              <span><strong>Version</strong>{{ app.latestVersion }}</span>
              <span><strong>Size</strong>{{ app.fileSize }}</span>
              <span><strong>OS</strong>{{ app.androidVersion }}</span>
              <span><strong>Type</strong>{{ app.fileType }}</span>
            </div>
            <button
              class="primary-btn inline-btn"
              type="button"
              :disabled="!apk"
              @click="gotodownload"
            >
              Download APK File
            </button>
          </div>

          <aside class="info-panel" aria-label="GB WhatsApp APK file details">
            <div class="info-panel-header">
              <div>
                <p>File details</p>
                <strong>{{ app.name }}</strong>
              </div>
              <span class="version-badge">{{ app.latestVersion }}</span>
            </div>
            <table>
              <tbody>
                <tr v-for="row in rows" :key="row[0]">
                  <th scope="row">{{ row[0] }}</th>
                  <td>
                    <router-link
                      v-if="row[0] === 'App Name'"
                      :to="{ name: 'en-gb' }"
                    >
                      {{ row[1] }}
                    </router-link>
                    <template v-else>{{ row[1] }}</template>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="info-panel-footer">
              <button
                class="table-btn"
                type="button"
                :disabled="!apk"
                @click="gotodownload"
              >
                Start Download
              </button>
            </div>
          </aside>
        </div>
      </section>

      <section class="content-section muted">
        <div class="page-shell">
          <h2>Things to Check Before Installing GB WhatsApp APK</h2>
          <p class="section-lead">{{ copy.section2Intro }}</p>
          <div class="steps-grid">
            <article class="step-card">
              <h3>Check Android Compatibility</h3>
              <p>
                Make sure your device supports APK installation and has enough
                storage space for the file and app data. This page lists
                {{ app.androidVersion }} as the basic requirement for current
                APK information.
              </p>
            </article>
            <article class="step-card">
              <h3>Enable Unknown Sources</h3>
              <p>
                Android may block APK files from outside the Play Store. Allow
                installation from unknown sources for your browser or file
                manager before you open the downloaded APK file.
              </p>
            </article>
            <article class="step-card">
              <h3>Backup Important Chats</h3>
              <p>
                Backup important WhatsApp data before installing a modified app,
                especially if you plan to move chats or update from an older GB
                WhatsApp version.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section class="content-section install-section">
        <div class="page-shell">
          <header class="install-header">
            <h2>How to Install GB WhatsApp APK</h2>
            <p>{{ copy.installIntro }}</p>
          </header>
          <ol class="install-panel">
            <li>
              <span class="install-num">1</span>
              <div>
                <strong>Download</strong>
                <p>Download the APK file from this page.</p>
              </div>
            </li>
            <li>
              <span class="install-num">2</span>
              <div>
                <strong>Open file</strong>
                <p>Open the downloaded file on your Android phone.</p>
              </div>
            </li>
            <li>
              <span class="install-num">3</span>
              <div>
                <strong>Install</strong>
                <p>Complete the installation screen and open the app.</p>
              </div>
            </li>
          </ol>
        </div>
      </section>

      <section class="content-section muted">
        <div class="page-shell">
          <h2>FAQ</h2>
          <div class="faq-list">
            <article v-for="faq in faqs" :key="faq[0]" class="faq-item">
              <h3>{{ faq[0] }}</h3>
              <p>{{ faq[1] }}</p>
            </article>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import BreadcrumbNav from '@/components/BreadcrumbNav.vue'
import {
  appInfo,
  downloadDetails,
  downloadFaqs,
  downloadCopy,
} from '@/content/gbwapps'
import { DOWNLOAD_API_PARAMS, DOWNLOAD_APK_URL } from '@/config/site'
import '@/css/base.scss'

const fallbackApk = () => DOWNLOAD_APK_URL

export default {
  name: 'Download',
  components: {
    HeadNav,
    BreadcrumbNav,
  },
  data() {
    return {
      app: appInfo,
      rows: downloadDetails,
      faqs: downloadFaqs,
      copy: downloadCopy,
      apk: fallbackApk(),
      from: 'gb',
      filename: 'gb',
    }
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from
    this.filename = this.$global.GetQueryString('filename') || this.filename
    this.apk = fallbackApk()
  },
  methods: {
    // 推广渠道 APK
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = fallbackApk()
          } else {
            this.apk = fallbackApk()
          }
        })
        .catch(() => {
          this.apk = fallbackApk()
        })
    },
    // 官方配置 APK 接口（与站点其他页一致）
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || DOWNLOAD_API_PARAMS.domain,
          appName: appname || DOWNLOAD_API_PARAMS.appName,
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = fallbackApk()
            }
          } else {
            this.apk = fallbackApk()
          }
        })
        .catch(() => {
          this.apk = fallbackApk()
        })
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk)
        this.$logEvent('download_from_download_page', 'download')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.gb-page {
  background: #ffffff;
  color: #111111;
  font-family: 'Lora', Georgia, serif;
  font-size: 16px;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
}

.page-shell {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
}

.download-hero {
  padding: 58px 0;
  background: #eefaf2;
  border-bottom: 1px solid #dce9e2;
  text-align: center;

  p {
    max-width: 720px;
    margin: 16px auto 0;
  }
}

.eyebrow {
  margin: 0 0 12px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 34px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0;
}

h2 {
  margin: 0 0 14px;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: 0;
}

h3 {
  margin: 0 0 8px;
  color: #111111;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.3;
}

p,
li {
  color: #222222;
  line-height: 1.625;
}

.section-lead {
  margin: 0 0 20px;
  max-width: 780px;
}

.primary-btn,
.table-btn {
  min-height: 50px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: #16a34a;
  color: #ffffff;
  text-decoration: none;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(22, 163, 74, 0.24);
}

.primary-btn {
  margin-top: 24px;
}

.inline-btn {
  margin-top: 8px;
}

.table-btn {
  width: 100%;
  min-height: 48px;
  margin: 0;
  box-sizing: border-box;
}

.primary-btn:disabled,
.table-btn:disabled {
  opacity: 0.65;
  cursor: wait;
}

.content-section {
  padding: 56px 0;
}

.muted {
  background: #f6faf8;
}

.section-kicker {
  margin: 0 0 8px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.file-section {
  background:
    radial-gradient(circle at 88% 18%, rgba(22, 163, 74, 0.08), transparent 32%),
    #ffffff;
}

.file-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
  gap: 28px;
  align-items: start;
}

.file-copy p {
  max-width: 560px;
}

.file-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 18px 0 8px;
}

.file-chips span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #d7e8de;
  border-radius: 999px;
  background: #f7fcf9;
  color: #33443b;
  font-size: 14px;
}

.file-chips strong {
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
}

.info-panel {
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 16px 32px rgba(16, 37, 28, 0.08);
}

.info-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 20px;
  background: linear-gradient(180deg, #10251c 0%, #163528 100%);
  color: #ffffff;

  p {
    margin: 0 0 4px;
    color: #8fd9ae;
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 12px;
    text-transform: uppercase;
  }

  strong {
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
  }
}

.version-badge {
  flex: 0 0 auto;
  min-height: 34px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #16a34a;
  color: #ffffff;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
}

.info-panel-footer {
  padding: 16px 18px 18px;
  background: #f7fcf9;
  border-top: 1px solid #e5ece8;
}

.step-card,
.faq-item {
  background: #ffffff;
  border: 1px solid #dce9e2;
  border-radius: 8px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 14px 16px;
  border-bottom: 1px solid #e5ece8;
  text-align: left;
}

th {
  width: 42%;
  background: #f6faf8;
  color: #294038;
}

tr:last-child th,
tr:last-child td {
  border-bottom: 0;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.step-card,
.faq-item {
  padding: 22px;
}

.readable {
  max-width: none;
}

.install-section {
  background:
    radial-gradient(circle at 12% 20%, rgba(22, 163, 74, 0.08), transparent 36%),
    linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
}

.install-header {
  max-width: 720px;
  margin-bottom: 24px;

  p {
    margin: 0;
  }
}

.install-panel {
  margin: 0;
  padding: 22px;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  border: 1px solid #d7e8de;
  border-radius: 16px;
  background:
    linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
  box-shadow: 0 14px 30px rgba(16, 37, 28, 0.06);
}

.install-panel li {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin: 0;
  padding: 18px 16px;
  border: 1px solid #e5ece8;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(16, 37, 28, 0.04);
}

.install-panel strong {
  display: block;
  margin-bottom: 6px;
  color: #10251c;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.install-panel p {
  margin: 0;
  color: #33443b;
  font-size: 15px;
  line-height: 1.5;
}

.install-num {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #16a34a;
  color: #ffffff;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  box-shadow: 0 8px 16px rgba(22, 163, 74, 0.28);
}

.faq-list {
  display: grid;
  gap: 14px;
}

@media (max-width: 820px) {
  .file-layout,
  .steps-grid,
  .install-panel {
    grid-template-columns: 1fr;
  }

  h1 {
    font-size: 28px;
  }
}
</style>
